const about = {
  name: "Prajwal Mainali",
  heroText: [
    "Strategic",
    "Creative",
    "Results-Driven",
    "Data-Savvy",
    "Innovative",
    "Adaptive",
    "Collaborative",
  ],
  title: "Business Expert",
  bio: "Experienced marketing expert driving impactful strategies, boosting brand visibility, and delivering measurable results. Passionate about crafting compelling narratives and driving business growth through innovative marketing solutions.",
  phone: "+977-9862169843",
  email: "prajwalmainaliprajwal@gmail.com",
  address: "Kanchanbari \nBiratnagar - 03 \nMorang, Nepal",
  socials: [
    {
      href: "https://www.linkedin.com/in/prajwal-mainali-399a45192",
      src: "https://cdn-icons-png.flaticon.com/512/174/174857.png",
      alt: "linkedin",
    },
    {
      href: "https://www.facebook.com/prajwal.mainali.14",
      src: "https://cdn-icons-png.flaticon.com/512/733/733547.png",
      alt: "facebook",
    },
    {
      href: "https://www.instagram.com/prajwalmainali/",
      src: "https://cdn-icons-png.flaticon.com/512/733/733558.png",
      alt: "instagram",
    },
    {
      href: "https://twitter.com/mainaliprajwal",
      src: "https://cdn-icons-png.flaticon.com/512/733/733579.png",
      alt: "twitter",
    },
  ],
  about:
    "I am Prajwal Mainali, a dedicated and accomplished business management graduate. I recently completed my degree at XYZ University, and I am excited to embark on the next chapter of my professional journey. \nThroughout my academic years, I consistently strived for excellence and maintained a strong academic record. I immersed myself in a variety of business courses, which provided me with a solid foundation in key areas such as finance, marketing, and organizational behavior. I eagerly engaged with industry-relevant projects and case studies, enhancing my problem-solving and analytical skills. \nDuring my time in university, I actively sought opportunities to gain practical experience and apply my knowledge in real-world settings. I secured internships with prominent companies, where I worked alongside professionals in cross-functional teams. These experiences allowed me to contribute to meaningful projects, such as process optimization and market research, while developing a deeper understanding of business operations. \nI actively participated in extracurricular activities and assumed leadership roles within student organizations. These opportunities sharpened my communication and teamwork skills, as well as provided a platform to organize events and foster professional connections. \nNow, as a business management graduate, I am poised to make a positive impact in the corporate world. I am eager to apply my expertise in strategic planning, data analysis, and effective decision-making to contribute to organizational success. I am committed to continuous learning, staying up-to-date with industry trends, and leveraging emerging technologies to drive innovation and sustainable growth. \nWith a solid academic foundation, practical experience, and a passion for success, I am confident in my ability to excel in the field of business management and make a valuable contribution to any organization I join.",
};

const skills = [
  {
    id: 1,
    name: "Leadership",
    level: "90",
  },
  {
    id: 2,
    name: "Strategic Thinking",
    level: "80",
  },
  {
    id: 3,
    name: "Problem Solving",
    level: "70",
  },
  {
    id: 4,
    name: "Communication",
    level: "70",
  },
  {
    id: 5,
    name: "Teamwork and Collaboration",
    level: "70",
  },
  {
    id: 6,
    name: "Adaptability",
    level: "80",
  },
  {
    id: 7,
    name: "Data Analysis",
    level: "70",
  },
  {
    id: 8,
    name: "Project Management",
    level: "70",
  },
  {
    id: 9,
    name: "Quick Learner",
    level: "70",
  },
];

const experiences = [
  {
    title: "Business Development Intern",
    company: "Biratnagar International College",
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, voluptatum.",
    date: "09/2021 - 01/2022",
  },
];

const education = [
  {
    id: 1,
    school: "Eden National Boarding School",
    degree: "Secondary Education",
    date: "2005 - 2016",
  },
  {
    id: 2,
    school: "Shikshadeep Boarding Higher Secondary School",
    degree: "Higher Secondary Education",
    field: "Management",
    date: "2017 - 2018",
  },
  {
    id: 3,
    school: "Biratnagar International College",
    degree: "Bachelor's Degree",
    field: "BSc. (Hons) International Business Management",
    date: "2019 - 2023",
  },
];

export { about, skills, experiences, education };
